import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPerson = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("circle", {
		id: "r1b4ls62ca",
		cx: 24,
		cy: 24,
		r: 24
	}) }), /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("mask", {
				id: "y35lsnf45b",
				fill: "#fff",
				children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#r1b4ls62ca" })
			}),
			/* @__PURE__ */ _jsx("use", {
				fill: "#FFF",
				xlinkHref: "#r1b4ls62ca"
			}),
			/* @__PURE__ */ _jsx("g", {
				fill: "#659DFE",
				mask: "url(#y35lsnf45b)",
				opacity: .494,
				children: /* @__PURE__ */ _jsxs("g", {
					transform: "translate(4 4)",
					children: [/* @__PURE__ */ _jsx("circle", {
						cx: 20,
						cy: 38,
						r: 20
					}), /* @__PURE__ */ _jsx("circle", {
						cx: 20,
						cy: 8,
						r: 8
					})]
				})
			})
		] })
	})]
});
export default SvgPerson;
